import { Controller } from "@hotwired/stimulus"
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['text']
  static values = { totalPages: Number, transitionName: String }
  static outlets = ['slide-images']

  initialize() {
    this.intersectionObserver = new IntersectionObserver(this.#toggle, { rootMargin: '-100% 0px 0px' })
    this.resizeObserver = new ResizeObserver(this.#setPosition)
  }

  slideImagesOutletConnected(outlet, element) {
    this.intersectionObserver.observe(element)
    this.resizeObserver.observe(document.scrollingElement)
  }

  slideImagesOutletDisconnected(outlet, element) {
    this.intersectionObserver.unobserve(element)
    this.resizeObserver.unobserve(document.scrollingElement)
  }

  updatePage(page) {
    this.textTarget.textContent = `${ page } of ${ this.totalPagesValue }`
  }

  #toggle = entries => {
    if (entries[0].isIntersecting) {
      enter(this.element, this.transitionNameValue)
    } else {
      leave(this.element, this.transitionNameValue)
    }
  }

  #setPosition = () => {
    const base = window.scrollX + this.slideImagesOutlet.element.getBoundingClientRect().left

    this.element.style.right = (base > 0) ? `${ base }px` : null
  }
}
